// Canonical enums for the new event/stat data model (adRequest / adResponse /
// adResponseEvent). ONE source of truth: PG (via Drizzle `.$type<>()`), the
// ClickHouse `Enum8` (codegen'd below), cold storage, and the frontend all
// import THESE. Stored as an integer on the DB.
//
// Values are STABLE — appending a new variant is safe (use the next integer);
// renumbering breaks existing rows. Keep codes in 0..127 so the ClickHouse
// Enum8 mirror (Int8-backed) stays valid.
// Which serving lane produced a request / response.
export var RequestSource;
(function (RequestSource) {
    RequestSource[RequestSource["Vast"] = 0] = "Vast";
    RequestSource[RequestSource["Rtb"] = 1] = "Rtb";
})(RequestSource || (RequestSource = {}));
// Lifecycle / outcome event recorded in `adResponseEvent`. The bid/serve itself
// is the EXISTENCE of an `adResponse` row (no status needed there). `NoBid` is
// reserved — no-bids are NOT persisted as rows; the bid-rate denominator is the
// `adRequest` count. `Win`/`Loss`/`Billable` population is feature-gated
// ("if needed"); only the serve + `Impression` are instrumented today.
export var AdResponseStatus;
(function (AdResponseStatus) {
    AdResponseStatus[AdResponseStatus["NoBid"] = 0] = "NoBid";
    AdResponseStatus[AdResponseStatus["Loss"] = 1] = "Loss";
    AdResponseStatus[AdResponseStatus["Win"] = 2] = "Win";
    AdResponseStatus[AdResponseStatus["Billable"] = 3] = "Billable";
    AdResponseStatus[AdResponseStatus["Impression"] = 4] = "Impression";
    // VAST tracking events + click, from the /vast/evt beacon (exchange counters
    // for CTR / VCR). Appended — codes are stable.
    AdResponseStatus[AdResponseStatus["Start"] = 5] = "Start";
    AdResponseStatus[AdResponseStatus["FirstQuartile"] = 6] = "FirstQuartile";
    AdResponseStatus[AdResponseStatus["Midpoint"] = 7] = "Midpoint";
    AdResponseStatus[AdResponseStatus["ThirdQuartile"] = 8] = "ThirdQuartile";
    AdResponseStatus[AdResponseStatus["Complete"] = 9] = "Complete";
    AdResponseStatus[AdResponseStatus["Click"] = 10] = "Click";
    AdResponseStatus[AdResponseStatus["Skip"] = 11] = "Skip";
    // Popunder lifecycle (Phase 1). Conversion = a tracker postback for a
    // registration / deposit; PopVisit = an admitted redirect; PopConfirmed = the
    // visit is confirmed (tracker landing postback, or fingerprint match).
    // Popunder revenue needs PopVisit AND PopConfirmed; cost needs Billable.
    AdResponseStatus[AdResponseStatus["Conversion"] = 12] = "Conversion";
    AdResponseStatus[AdResponseStatus["PopVisit"] = 13] = "PopVisit";
    AdResponseStatus[AdResponseStatus["PopConfirmed"] = 14] = "PopConfirmed";
})(AdResponseStatus || (AdResponseStatus = {}));
// The /vast/evt beacon's `e` parameter mapped onto the stored status. One map so
// the route, the injected tracking URLs and the reports cannot drift.
export const VAST_EVENT_STATUS = {
    start: AdResponseStatus.Start,
    q1: AdResponseStatus.FirstQuartile,
    mid: AdResponseStatus.Midpoint,
    q3: AdResponseStatus.ThirdQuartile,
    complete: AdResponseStatus.Complete,
    click: AdResponseStatus.Click,
    skip: AdResponseStatus.Skip,
};
// --- ClickHouse Enum8 codegen ---------------------------------------------
//
// Generate the CH `Enum8('name'=code, ...)` string directly from the TS enum so
// the two can NEVER drift (the drift that would zero all confirmed-serve money).
// TS numeric enums carry both forward (name->code) and reverse (code->name)
// mappings; we keep only the forward, numeric-valued entries.
export const chEnum8 = (e) => {
    const forward = Object.entries(e).filter((kv) => typeof kv[1] === "number");
    return `Enum8(${forward
        .map(([name, code]) => `'${name.toLowerCase()}'=${code}`)
        .join(",")})`;
};
// e.g. "Enum8('nobid'=0,'loss'=1,'win'=2,'billable'=3,'impression'=4)"
export const AD_RESPONSE_STATUS_CH_ENUM8 = chEnum8(AdResponseStatus);
// e.g. "Enum8('vast'=0,'rtb'=1)"
export const REQUEST_SOURCE_CH_ENUM8 = chEnum8(RequestSource);
//# sourceMappingURL=adEvent.js.map